import { Avatar, Box, Stack } from "@mui/material";
import { Custom } from "components";
import { useApp, useTheme } from "contexts";
import { ICategory, IMenu } from "interfaces";
import { Combines } from "helpers";
import { Helpers } from "utils";

type Props = {
  open: boolean;
  categories: ICategory[];
  onClose: () => void;
};

export const ViewMenu = ({ open, categories, onClose }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  return (
    <Custom.Modal
      open={open}
      onClose={onClose}
      title={t.component.popup.view_menu.title}
    >
      <Box>
        <Stack spacing={theme.spacing.md}>
          <Custom.Typography
            align="center"
            size={theme.font.xs}
            weight={theme.font.bold}
          >
            {t.component.popup.view_menu.headline}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box
        sx={{
          border: 1,
          maxHeight: 300,
          overflowY: "auto",
          mt: theme.spacing.md,
          borderRadius: theme.border.radius,
          borderColor: theme.color.border.color,
        }}
      >
        <Stack>
          {categories.map((item: ICategory, i: number) => (
            <Box
              key={i}
              sx={
                i === 0
                  ? {}
                  : { borderTop: 1, borderColor: theme.color.border.color }
              }
            >
              <Stack
                direction="row"
                alignItems="center"
                px={theme.spacing.sm}
                py={theme.spacing.sm}
                spacing={theme.spacing.sm}
              >
                <Custom.Avatar
                  alt={item.suggested_by.first_name}
                  src={Helpers.getUserAvatar(item.suggested_by._id)}
                />
                <Stack
                  width={1}
                  sx={{
                    textDecoration: item.cancelled ? "line-through" : undefined,
                  }}
                >
                  <Custom.Typography
                    size={theme.font.sm}
                    weight={theme.font.bold}
                  >
                    {i + 1}. {item.name}
                  </Custom.Typography>
                  <Box width={1}>
                    <Stack direction="row" justifyContent="space-between">
                      <Custom.Typography size={theme.font.xs}>
                        {t.label.from}:{" "}
                        {`${item.suggested_by.first_name} ${item.suggested_by.last_name}`}
                      </Custom.Typography>
                      <Custom.Typography
                        size={theme.font.xs}
                        weight={theme.font.bold}
                      >
                        {Combines.interpolate(t.message.responses, {
                          count: item.responses.length,
                        })}
                      </Custom.Typography>
                    </Stack>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          ))}
        </Stack>
      </Box>
      <Custom.Button
        fullWidth
        trailing="right"
        variant="contained"
        sx={{ mt: theme.spacing.md }}
        onClick={onClose}
      >
        {t.action.return_main}
      </Custom.Button>
    </Custom.Modal>
  );
};
